module.exports = __webpack_public_path__ + "static/media/breakfast-brunch-mobile-411x93.4f99f111.jpg";